
import {
    faImage, faTimes, faCog, faArrowDown, faArrowsAltH, faArrowsAltV, faPlus, faMinus
} from '@fortawesome/free-solid-svg-icons';

export const RED = '#d5001c';
export const WHITE = '#ffffff'
export const CROP = "crop";
export const VIEW = "view";
export const EDIT = "edit";
export const NONE = "none";
export const BLOCK = "block";
export const ICON_RED = { color: RED };
export const ICON_WHITE = { color: WHITE };
export const BUTTON = "button";
export const FREE = "free";
export const CLOSE = "close";
export const NEW_CLIP = "newclip";
export const MEDIA_FILE = "mediafile";
export const THUMBNAIL = "thumbnail";
export const INPUT = "input";
export const DEFAULT_WIDTH = 400;
export const DEFAULT_HEIGHT = 400;
export const QUESTIONTYPE = 'questionType';
export const IMAGETYPE = 'imageType';
export const MIN_SIZE = 1200;
export const PROJECT = 'project';
export const ROOM = 'room';
export const PREVIEWTYPE = 'previewType';
export const PRESETS = 'presets';
export const LOCALHOST = 'http://localhost:3000';
export const PLUS = 'plus';
export const STEP = 0.1;
export const SCALE_MAX = 3.2;
export const SCALE_MIN = 0.1;
export const CARRERATV = "800x390";
export const CAROUSEL = "carousel";
export const MODE_TEST = true;
export const PRESETS_TIME = 2000;

export const CLOSE_ITEMS = [
    { name: "data.crop.close", value: "close", intl: "data.crop.close", type: "button", icon: faTimes },
]

export const IMPORT_ITEMS = [
    // { name: "data.crop.import.newclip", value: NEW_CLIP, intl: "data.crop.import.newclip", type: "button", icon: faCamera },
    // { name: "data.crop.import.mediafile", value: MEDIA_FILE, intl: "data.crop.import.mediafile", type: "button", icon: faImage },
    // { name: "data.crop.import.thumbnail", value: THUMBNAIL, intl: "data.crop.import.thumbnail", type: "button", icon: faImage },
    { name: "data.crop.import.import", value: MEDIA_FILE, intl: "data.crop.import.import", type: "button", icon: faImage },
]


export const SETTINGS_BTN_ITEMS = [
    { name: "plus", intl: "", type: "button", icon: faPlus, onClick: "onResizeBtnClick" },
    { name: "minus", intl: "", type: "button", icon: faMinus, onClick: "onResizeBtnClick" },
    { name: "fliph", intl: "data.crop.settings.fliph", type: "button", icon: faArrowsAltH, onClick: "onFlipBtnClick" },
    { name: "flipv", intl: "data.crop.settings.flipv", type: "button", icon: faArrowsAltV, onClick: "onFlipBtnClick" },
    { name: "reset", intl: "data.crop.settings.reset", type: "button", icon: faCog, onClick: "onResetBtnClick" },
]

export const SETTINGS_INPUT_ITEMS = [
    { name: "x", intl: "data.crop.settings.X", type: "input", icon: faImage, onChange: "onChangeSettings" },
    { name: "y", intl: "data.crop.settings.Y", type: "input", icon: faImage, onChange: "onChangeSettings" },
    { name: "width", intl: "data.crop.settings.W", type: "input", icon: faImage, onChange: "onChangeSettings" },
    { name: "height", intl: "data.crop.settings.H", type: "input", icon: faImage, onChange: "onChangeSettings" },
]

export const NEWCLIP_CONTENT_ITEMS = [
    { name: "title", intl: "data.crop.newclip.title", type: "input" },
    // { name: "filename", intl: "data.crop.newclip.filename", type: "input" },
]

export const NEWCLIP_BTN_ITEMS = [
    { name: "cancel", intl: "data.crop.cancel", icon: faTimes, htmlclass: "custom-btn", onClick: "closePopUp" },
    { name: "import", intl: "data.crop.save", icon: faArrowDown, htmlclass: "custom-btn-active", onClick: "confirmPopUp" },
]